import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import ProcedureMoveAppBar from "../../../common/ProcedureMoveAppBar";
import Snackbar from "../../../common/Snackbar";
import { copyElement } from "../../../redux/sectionSlice";
import { generateSHA256 } from "../../../util/generateSHA256";
import { getPages, renderPreview, renderVideo } from "../plugins/utils";
import RenderHtml from "../../../common/AppSpecificConpnents/PartsTable/RenderHtml";
import {
  calculateGroupHeight,
  calculateTextBlockWidth,
  estimateKonvaTextHeight,
  formatListContent,
  getTextStyle,
  hasNoteContent,
  hasTaskContent,
  hasUserContent,
  measureHtmlHeight,
  stripHtmlPreserveFormatting,
} from "../../SectionElements/plugins/utils.js";
import RectangleElement from "../../Canvas/components/rectangle/RectangleElement.jsx";
import ArrowElement from "../../Canvas/components/arrow/ArrowElement.jsx";
import CircleElement from "../../Canvas/components/circle/CircleElement.jsx";
import LineElement from "../../Canvas/components/line/LineElement.jsx";
import CanvasImage from "../../Canvas/components/canvas-core/CanvasImage.jsx";
import TextElement from "../../Canvas/components/text/TextElement.jsx";
import DoubleSidedArrowElement from "../../Canvas/components/arrow/DoubleSidedArrowElement.jsx";
import CanvasDisplay from "../../Canvas/components/canvas-core/CanvasDisplay.jsx";
import {
  generateSourceTreePath,
  generateTargetTreePath,
  getDisplayIndex,
  getSubstepLetter,
  generateStatusText,
  validateAndCorrectTreePathData,
  generateCompleteTreePath,
} from "../../SubassemblyDetails/utils/treePathUtils";
const ProcedureSubstepCopyPreview = () => {
  const { sections } = useSelector((state) => state.section);
  const [videosForSubsteps, setVideosForSubsteps] = useState({});
  const [formsForSubsteps, setFormsForSubsteps] = useState({});
  const [richTextsForSubsteps, setRichTextsForSubsteps] = useState({});
  const [attachmentsForSubsteps, setAttachmentsForSubsteps] = useState({});
  const [canvasesForSubsteps, setCanvasesForSubsteps] = useState({});
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    stepsBySection,
    substepsByStep,
    richTexts,
    attachments,
    forms,
    canvases,
    videos,
  } = useSelector((state) => state.step);
  const [substepsByStepPreview, setSubstepsByStepPreview] = useState(
    substepsByStep || {}
  );
  let richTextCounter = 1;
  let canvasCounter = 1;
  let videoCounter = 1;
  let formCounter = 1;
  let substepCounter = 1;
  let stepCounter = 1;
  const [isLoading, setIsLoading] = useState(false);
  const [auditData, setAuditData] = useState({
    user_ref: localStorage.getItem("user_id") || "",
    ip_address: "",
    device_info: navigator.userAgent,
    hash: generateSHA256(Math.random().toString()),
    signature: "",
  }); // Fetch IP address and generate hash
  let richTextsCounter = {};
  let attachmentCounter = 1;
  const [isModalOpen, setModalOpen] = useState(false);
  const [comment, setComment] = useState("");
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    type: "",
  });

  const [stepsBySectionPreview, setStepsBySectionPreview] = useState({});

  const [selectedView, setSelectedView] = useState("new");

  const {
    moveType,
    sourceSectionIndex,
    targetSectionIndex,
    revision,
    partNumber,
    type,
    partId,
    revisionId,
    fromTreeId,
    fromSectionId,
    targetSectionData,
    fromSiblingOrder,
    fromStepId,
    fromSubstepId,
    fromPartId,
    fromRevisionId,
    title,
    status,
    toType,
    toPartNumber,
    description,
    treeNode,
    selectedNodeInfo,
  } = location.state;
  const [previewSections, setPreviewSections] = useState([...sections]);

  const showSnackbar = (message, type) => {
    setSnackbar({ open: true, message, type });
  };

  useEffect(() => {
    const {
      substep,
      moveType,
      richTexts,
      attachments,
      canvases,
      forms,
      videos,
    } = location.state;

    // Add null check and error handling for substep
    if (!substep) {
      console.error(
        "Substep data is missing from location.state:",
        location.state
      );
      showSnackbar(
        "Error: Substep data is missing. Please try again.",
        "error"
      );
      return;
    }

    const targetStepId = targetSectionData?.stepId;
    const targetSubstepId = targetSectionData?.substepId;

    if (!targetStepId) {
      console.error(
        "Target step ID is missing from targetSectionData:",
        targetSectionData
      );
      showSnackbar(
        "Error: Target step data is missing. Please try again.",
        "error"
      );
      return;
    }

    const sourceSubstepId = substep.sub_step_tree_node_id;
    if (!sourceSubstepId) {
      console.error("Source substep ID is missing from substep:", substep);
      showSnackbar(
        "Error: Source substep ID is missing. Please try again.",
        "error"
      );
      return;
    }

    if (!targetStepId || !sourceSubstepId) return;

    const newSubstepId = `${sourceSubstepId}`; // ID stays same unless duplicating

    const clonedSubstep =
      selectedView === "original"
        ? substep
        : {
            ...structuredClone(substep),
            sub_step_tree_node_id: newSubstepId,
          };

    const cloneHelper = (items, key) =>
      selectedView === "original"
        ? (items && items[sourceSubstepId]) || []
        : ((items && items[sourceSubstepId]) || []).map((item) => ({
            ...structuredClone(item),
            [key]: `${item[key]}`,
          }));

    const clonedRichTexts = cloneHelper(richTexts, "rich_text_tree_node_id");
    const clonedAttachments = cloneHelper(
      attachments,
      "attachment_tree_node_id"
    );
    const clonedCanvases = cloneHelper(canvases, "canvas_tree_node_id");
    const clonedForms = cloneHelper(forms, "form_tree_node_id");
    const clonedVideos = cloneHelper(videos, "video_tree_node_id");

    // ✅ Combine Redux state with any preview overrides if needed
    // Combine Redux substeps + location.state.step.substeps (if targeting same step)
    const previewStepFromState = location.state.step;
    const previewSubsteps =
      previewStepFromState?.step_tree_node_id === targetStepId
        ? previewStepFromState.substeps || []
        : [];

    const reduxSubsteps = substepsByStep[targetStepId] || [];

    const mergedSubstepsMap = new Map();
    // Deduplicate by sub_step_tree_node_id
    [...reduxSubsteps, ...previewSubsteps].forEach((s) =>
      mergedSubstepsMap.set(s.sub_step_tree_node_id, s)
    );

    let existingSubsteps = Array.from(mergedSubstepsMap.values()).sort(
      (a, b) => {
        const orderA = a.sibling_order || a.procedure_tree?.sibling_order;
        const orderB = b.sibling_order || b.procedure_tree?.sibling_order;

        const orderCompare = compareSiblingOrders(orderA, orderB);
        if (orderCompare !== 0) return orderCompare;

        // Fallback: compare created_at
        const dateA = new Date(a.created_at);
        const dateB = new Date(b.created_at);
        return dateB - dateA; // latest comes first
      }
    );

    let insertAt = existingSubsteps.length;

    if (moveType === "up" || moveType === "below") {
      const targetIndex = existingSubsteps.findIndex(
        (s) => s.sub_step_tree_node_id === targetSubstepId
      );

      if (targetIndex !== -1) {
        insertAt = moveType === "up" ? targetIndex : targetIndex + 1;
      } else {
        console.warn("Target substep not found. Appending at end.");
      }
    }

    // ✅ Inject the substep in correct position
    const updatedSubsteps =
      selectedView === "original"
        ? existingSubsteps
        : [
            ...existingSubsteps.slice(0, insertAt),
            clonedSubstep,
            ...existingSubsteps.slice(insertAt),
          ];

    setSubstepsByStepPreview((prev) => ({
      ...substepsByStep, // From Redux
      ...prev, // Existing preview edits
      [targetStepId]: updatedSubsteps, // Replace only target step's substeps
    }));

    setRichTextsForSubsteps((prev) => ({
      ...prev,
      [newSubstepId]: clonedRichTexts,
    }));

    setAttachmentsForSubsteps((prev) => ({
      ...prev,
      [newSubstepId]: clonedAttachments,
    }));

    setCanvasesForSubsteps((prev) => ({
      ...prev,
      [newSubstepId]: clonedCanvases,
    }));

    setFormsForSubsteps((prev) => ({
      ...prev,
      [newSubstepId]: clonedForms,
    }));

    setVideosForSubsteps((prev) => ({
      ...prev,
      [newSubstepId]: clonedVideos,
    }));
  }, [
    selectedView,
    stepsBySection,
    substepsByStep,
    location.state,
    targetSectionData,
  ]);

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const handleConfirm = () => {
    setModalOpen(true);
  };

  const compareSiblingOrders = (a, b) => {
    const intA = parseInt(a, 10);
    const intB = parseInt(b, 10);
    return intA - intB;
  };
  useEffect(() => {
    fetch("https://api.ipify.org?format=json")
      .then((res) => res.json())
      .then((data) =>
        setAuditData((prev) => ({ ...prev, ip_address: data.ip }))
      )
      .catch((err) => console.error("Failed to fetch IP:", err));
  }, []);

  const handleConfirmSave = async () => {
    if (!comment) {
      showSnackbar("Comment is mandatory.", "error");
      return;
    }

    setIsLoading(true); // Show the page loader

    const hash = await generateSHA256(Math.random().toString());

    let toOrder = parseInt(targetSectionData?.siblingOrder);
    let substepIndex = selectedNodeInfo?.substepIndex + 1;

    if (moveType === "up") {
      if (!selectedNodeInfo?.substepIndex) {
        console.error("No substep index found for move up");
        showSnackbar("Error: Invalid substep selection", "error");
        setIsLoading(false);
        return;
      }
      if (!targetSectionData?.sectionId) {
        console.error("No target section ID found for move up");
        showSnackbar("Error: Invalid target data", "error");
        setIsLoading(false);
        return;
      }
      toOrder = substepIndex;
    } else if (moveType === "below") {
      if (!selectedNodeInfo?.substepIndex) {
        console.error("No substep index found for move below");
        showSnackbar("Error: Invalid substep selection", "error");
        setIsLoading(false);
        return;
      }
      if (!targetSectionData?.sectionId) {
        console.error("No target section ID found for move below");
        showSnackbar("Error: Invalid target data", "error");
        setIsLoading(false);
        return;
      }
      toOrder = substepIndex + 1;
    } else {
      // When copying into a step, calculate the last substep's sibling order + 1
      const targetStepId = targetSectionData.stepId;

      if (!targetStepId) {
        console.error("No target step ID found when copying into step");
        showSnackbar("Error: No target step selected", "error");
        setIsLoading(false);
        return;
      }

      if (!targetSectionData.stepTreeId) {
        console.error("No target step tree ID found when copying into step");
        showSnackbar("Error: Invalid target step data", "error");
        setIsLoading(false);
        return;
      }

      if (!targetSectionData.sectionId) {
        console.error("No target section ID found when copying into step");
        showSnackbar("Error: Invalid target step data", "error");
        setIsLoading(false);
        return;
      }

      const existingSubsteps = substepsByStep[targetStepId] || [];

      if (existingSubsteps.length > 0) {
        // Find the highest sibling order among existing substeps
        const siblingOrders = existingSubsteps
          .map((substep) =>
            parseInt(
              substep.sibling_order ||
                substep.procedure_tree?.sibling_order ||
                0
            )
          )
          .filter((order) => !isNaN(order) && order > 0); // Filter out invalid orders

        if (siblingOrders.length > 0) {
          const maxSubstepOrder = Math.max(...siblingOrders);
          toOrder = maxSubstepOrder + 1;
        } else {
          // If no valid sibling orders found, start with 1
          toOrder = 1;
        }
      } else {
        // If no substeps exist, start with 1
        toOrder = 1;
      }
    }

    const payload = {
      from_procedure_tree_node_ref: fromTreeId,
      from_order: parseInt(fromSiblingOrder),
      from_type: "substep",
      from_part_id_ref: fromPartId,
      from_procedure_rev_ref: fromRevisionId,
      from_section_id_ref: fromSectionId,
      from_step_id_ref: fromStepId,
      from_substep_id_ref: fromSubstepId,
      to_procedure_tree_node_ref: targetSectionData?.sectionTreeId,
      to_order: toOrder,
      to_type: "substep",
      to_part_id_ref: partId,
      to_procedure_rev_ref: revisionId,
      to_section_id_ref: targetSectionData?.sectionId,
      to_step_id_ref: targetSectionData.stepId,
      to_substep_id_ref: targetSectionData.substepId
        ? targetSectionData.substepId
        : "",
      direction: moveType === "up" ? "paste_up" : "paste_down",
      audit_trail_data: {
        ...auditData,
        hash,
        action:
          moveType === "up"
            ? "paste_up"
            : moveType === "below"
            ? "paste_down"
            : "paste_into",
        comment:
          moveType === "into"
            ? `Copied substep to Step ${targetSectionData.globalStepNumber} in ${type} ${partNumber} ${revision}`
            : `Copied Section ${
                sourceSectionIndex !== undefined && sourceSectionIndex !== null
                  ? sourceSectionIndex + 1
                  : "Unknown"
              } to Section ${
                targetSectionIndex + 1
              } in ${type} ${partNumber} ${revision}`,
        date: new Date().toISOString(),
        parent_version: null,
        version_content: {
          rule_name: "Field Changes Tracking",
          modified_fields: {},
        },
      },
    };

    try {
      const result = await dispatch(copyElement(payload)).unwrap();
      setModalOpen(false);

      // Validate navigation parameters
      if (
        !partId ||
        !revision ||
        !toType ||
        !toPartNumber ||
        !revisionId ||
        !description
      ) {
        console.error("Missing navigation parameters:", {
          partId,
          revision,
          toType,
          toPartNumber,
          revisionId,
          description,
        });
        showSnackbar("Error: Invalid navigation data", "error");
        return;
      }

      if (!status) {
        console.error("Missing status for navigation");
        showSnackbar("Error: Invalid status data", "error");
        return;
      }

      navigate(
        `/revision-submission/${partId}/${revision}/${toType}/${toPartNumber}/${revisionId}/${description}`,
        { state: { status } }
      );
    } catch (error) {
      console.error("Error copying substep:", error);
      let errorMessage = "Failed to copy substep";

      if (error?.message) {
        errorMessage = error.message;
      } else if (error?.error) {
        errorMessage = error.error;
      } else if (typeof error === "string") {
        errorMessage = error;
      }

      showSnackbar(errorMessage, "error");
    } finally {
      setIsLoading(false); // Hide the page loader
    }
  };
  const getReorderedSections = (
    sections,
    sourceIndex,
    targetIndex,
    moveType
  ) => {
    return sections;
  };

  const reorderedPreviewSections = getReorderedSections(
    [
      ...previewSections,
      // .sort((a, b) => {
      //   const orderA = a.sibling_order || a.procedure_tree?.sibling_order;
      //   const orderB = b.sibling_order || b.procedure_tree?.sibling_order;

      //   const orderCompare = compareSiblingOrders(orderA, orderB);
      //   if (orderCompare !== 0) return orderCompare;

      //   // Fallback: compare created_at
      //   const dateA = new Date(a.created_at);
      //   const dateB = new Date(b.created_at);
      //   return dateB - dateA; // latest comes first
      // }),
    ],
    sourceSectionIndex,
    targetSectionIndex - 1,
    moveType
  );

  return (
    <div style={{ position: "relative" }}>
      {/* Main Page Loader */}
      {isLoading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <div
            style={{
              backgroundColor: "white",
              padding: "20px",
              borderRadius: "8px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
            }}
          >
            <div
              style={{
                border: "4px solid #f3f3f3",
                borderRadius: "50%",
                width: "40px",
                height: "40px",
                animation: "spin 1s linear infinite",
                marginBottom: "10px",
              }}
            ></div>
            <div style={{ fontSize: "16px", color: "#333" }}>
              Copying Substep...
            </div>
          </div>
        </div>
      )}

      <ProcedureMoveAppBar
        showBackButton={false}
        selectedView={selectedView}
        setSelectedView={setSelectedView}
        title="Please Confirm the Changes"
        buttons={[{ label: "Confirm", onClick: handleConfirm }]}
      />
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "20px",
          padding: "8px 20px",
          flexWrap: "wrap", // for responsiveness
        }}
      >
        {/* Checkbox + Title + Description */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <label
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              cursor: "pointer",
              margin: 0,
            }}
          >
            <span style={{ fontSize: "19px", fontWeight: 600 }}>
              {toType} {toPartNumber}
            </span>
          </label>

          {/* Description */}
          {/* <span style={{ marginLeft: "2px", marginTop: "5px", color: "#666" }}>
            Description: {description}
          </span> */}
        </div>

        {/* Right-aligned section */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "20px",
            marginLeft: "auto",
          }}
        >
          <div>
            <strong>Status: </strong>
            {/* <span style={{ color: "orange" }}>{status}</span> */}
            <span style={{ color: "orange" }}>
              {location.state.status || status}
            </span>
          </div>

          <div>
            <strong>Revision: </strong>
            <span>{revision}</span>
          </div>
        </div>
      </div>
      <div style={{ padding: "20px" }}>
        <div style={{ marginTop: "20px" }}>
          {reorderedPreviewSections
            .sort((a, b) => {
              const orderA = a.sibling_order || a.procedure_tree?.sibling_order;
              const orderB = b.sibling_order || b.procedure_tree?.sibling_order;

              const orderCompare = compareSiblingOrders(orderA, orderB);
              if (orderCompare !== 0) return orderCompare;

              // Fallback: compare created_at
              const dateA = new Date(a.created_at);
              const dateB = new Date(b.created_at);
              return dateB - dateA; // latest comes first
            })
            .map((section, index) => {
              const stepsToRender =
                stepsBySection[section.section_tree_node_id] || [];
              return (
                <div
                  className="header-spacing"
                  key={section.section_tree_node_id}
                  style={{
                    margin: "20px 0",
                  }}
                >
                  <label
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      cursor: "pointer",
                    }}
                  >
                    <h2 style={{ margin: 0, fontSize: "20px" }}>
                      Section {index + 1}
                    </h2>
                  </label>
                  <hr />
                  <hr />
                  <div>{section.section_name}</div>
                  <div>{section.short_description}</div>

                  {/* Steps for this section */}
                  {(stepsToRender || []).map((step, stepIndex) => {
                    const stepId = step.step_tree_node_id;
                    const sectionId = section.section_tree_node_id;
                    stepCounter++;
                    const stepsBeforeThisSection = previewSections
                      .slice(0, index)
                      .reduce(
                        (acc, s) =>
                          acc +
                          (stepsBySection[s.section_tree_node_id]?.length || 0),
                        0
                      );
                    const globalStepNumber =
                      stepsBeforeThisSection + stepIndex + 1;

                    const substeps = substepsByStep[stepId] || [];

                    const substepLetter = String.fromCharCode(
                      65 + substeps.length
                    ); // A, B, C...

                    // Calculate media counters before navigation
                    const currentAttachmentCounter = attachmentCounter;
                    const currentVideoCounter = videoCounter;
                    const currentFormCounter = formCounter;
                    const currentCanvasCounter = canvasCounter;
                    const currentRichTextCounter = richTextCounter;

                    // Update counters for next step
                    //attachmentCounter += myAttachments.length;
                    // videoCounter += myVideos.length;
                    // formCounter += myForms.length;
                    // canvasCounter += myCanvases.length;
                    // richTextCounter += myRichTexts.length; // If you're adding one richText per step

                    richTextsCounter[stepId] = currentRichTextCounter;

                    const combinedItems = [
                      ...(richTexts[stepId] || []).map((item) => ({
                        ...item,
                        type: "richText",
                      })),
                      ...(step.richTexts || []).map((item) => ({
                        ...item,
                        type: "richText",
                      })),
                      ...(forms[stepId] || []).map((item) => ({
                        ...item,
                        type: "form",
                      })),
                      ...(step.forms || []).map((item) => ({
                        ...item,
                        type: "form",
                      })),
                      ...(attachments[stepId] || []).map((item) => ({
                        ...item,
                        type: "attachment",
                      })),
                      ...(step.attachments || []).map((item) => ({
                        ...item,
                        type: "attachment",
                      })),
                      ...(canvases[stepId] || []).map((item) => ({
                        ...item,
                        type: "canvas",
                      })),
                      ...(step.canvases || []).map((item) => ({
                        ...item,
                        type: "canvas",
                      })),
                      ...(videos[stepId] || []).map((item) => ({
                        ...item,
                        type: "video",
                      })),
                      ...(step.videos || []).map((item) => ({
                        ...item,
                        type: "video",
                      })),
                    ]; // Filter out substeps or unwanted items (same as your current filter)
                    const filteredItems = combinedItems.filter(
                      (item) =>
                        !item.substep_id_ref && !item.sub_step_tree_node_id
                    );

                    filteredItems.sort((a, b) => {
                      const orderA =
                        a.sibling_order || a.procedure_tree?.sibling_order;
                      const orderB =
                        b.sibling_order || b.procedure_tree?.sibling_order;

                      const orderCompare = compareSiblingOrders(orderA, orderB);
                      if (orderCompare !== 0) return orderCompare;

                      // Fallback: compare created_at
                      const dateA = new Date(a.created_at);
                      const dateB = new Date(b.created_at);
                      return dateB - dateA; // latest comes first
                    });
                    const allChildrenUnderStep = [
                      ...(richTexts[stepId] || []),
                      ...(forms[stepId] || []),
                      ...(attachments[stepId] || []),
                      ...(canvases[stepId] || []),
                      ...(videos[stepId] || []),
                      // Also optionally substeps, if they have sibling_order
                    ];

                    return (
                      <div key={stepId} style={{ marginTop: "20px" }}>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                          }}
                        >
                          <label
                            style={{
                              display: "flex",
                              gap: "8px",
                              cursor: "pointer",
                            }}
                          >
                            <h2
                              style={{
                                margin: 0,
                                color: "#333",
                                fontSize: "20px",
                              }}
                            >
                              Step {globalStepNumber}
                            </h2>
                          </label>

                          <div
                            style={{
                              color: "#888",
                              fontSize: "14px",
                              fontWeight: "normal",
                            }}
                          >
                            {generateCompleteTreePath({
                              sectionIndex: index,
                              stepIndex: globalStepNumber - 1,
                              substepIndex: undefined,
                              nodeType: undefined,
                              nodeIndex: undefined,
                            })}
                          </div>
                        </div>
                        <hr />
                        <p style={{ whiteSpace: 'pre-wrap' }}>{step.short_description || ""}</p>
                        <p>
                          <p>
                            {structuredClone(step.step_details)
                              .sort(
                                (a, b) =>
                                  new Date(a.created_at) -
                                  new Date(b.created_at)
                              )
                              .map((myStep, index) => {
                                const partNumber =
                                  myStep.part_info?.part_number || "";
                                const description =
                                  myStep.part_info?.description || "";
                                const qtyText =
                                  myStep.qty && myStep.qty !== 0
                                    ? `Qty ${myStep.qty}`
                                    : "";

                                const partText = partNumber
                                  ? ` (${partNumber})`
                                  : "";

                                return (
                                  <span key={index}>
                                    {myStep.action}
                                    {partText}{" "}
                                    <RenderHtml content={description} />{" "}
                                    {qtyText}
                                    &nbsp;
                                  </span>
                                );
                              })}
                          </p>
                        </p>

                        <h4>
                          {step.bom_table_title_info?.category_name || ""}
                        </h4>

                        <table className="table">
                          <thead>
                            <tr>
                              <th>Type</th>
                              <th>
                                {
                                  step.part_number_column_title_ref_info
                                    ?.category_name
                                }{" "}
                              </th>
                              <th>Description</th>
                              <th>Qty Per</th>
                              <th>Unit</th>
                            </tr>
                          </thead>

                          <tbody>
                            {step.parts_required.map((row) => (
                              <tr>
                                <td>{row.part_info.type_info.name}</td>
                                <td>{row.part_info.part_number}</td>
                                <td>
                                  <RenderHtml
                                    content={row.part_info.description}
                                  />
                                </td>
                                <td>{row.qty === 0 ? "" : row.qty}</td>
                                <td>{row.part_info?.unit_info?.unit_name}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>

                        {/* Step Content */}

                        {filteredItems.map((item) => {
                          if (item.substep_id_ref || item.sub_step_tree_node_id)
                            return null;
                          switch (item.type) {
                            case "richText": {
                              const globalRichTextNumber = richTextCounter++; // ✅ use then increment
                              // render richText block here
                              const label = (
                                <h2 style={{ color: "#333", fontSize: "20px" }}>
                                  Rich Text {globalRichTextNumber}
                                </h2>
                              );

                              return (
                                <div
                                  className="header-spacing"
                                  key={item.rich_text_tree_node_id}
                                  style={{ marginTop: "20px" }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                    }}
                                  >
                                    <label
                                      style={{
                                        display: "flex",
                                        gap: "6px",
                                        cursor: "pointer",
                                      }}
                                    >
                                      {label}
                                    </label>

                                    <div
                                      style={{
                                        color: "#888",
                                        fontSize: "14px",
                                        fontWeight: "normal",
                                      }}
                                    >
                                      Section {index + 1} &gt; Step{" "}
                                      {globalStepNumber}
                                    </div>
                                  </div>
                                  <div
                                    style={{
                                      marginLeft: "5px",
                                      marginTop: "-10px",
                                    }}
                                  >
                                    {item.short_description}
                                  </div>
                                  <div
                                    style={{
                                      marginLeft: "4px",
                                      marginTop: "5px",
                                    }}
                                  >
                                    {item.category_data?.category_name}
                                  </div>
                                  <div
                                    style={{
                                      fontSize: "14px",
                                      marginLeft: "4px",
                                      marginTop: "5px",
                                    }}
                                  >
                                    <div
                                      style={{ marginTop: "-6px" }}
                                      dangerouslySetInnerHTML={{
                                        __html: item.rich_text_content,
                                      }}
                                    />
                                  </div>
                                </div>
                              );
                            }
                            case "video": {
                              const globalVideoNumber = videoCounter++; // ✅ use then increment
                              const label = (
                                <h2 style={{ color: "#333", fontSize: "20px" }}>
                                  Video {globalVideoNumber}
                                </h2>
                              );

                              return (
                                <div key={label} style={{ marginTop: "20px" }}>
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                    }}
                                  >
                                    <label
                                      style={{
                                        display: "flex",
                                        gap: "6px",
                                        cursor: "pointer",
                                      }}
                                    >
                                      {label}
                                    </label>

                                    <div
                                      style={{
                                        color: "#888",
                                        fontSize: "14px",
                                        fontWeight: "normal",
                                      }}
                                    >
                                      Section {index + 1} &gt; Step{" "}
                                      {globalStepNumber}
                                    </div>
                                  </div>

                                  {renderVideo(item)}

                                  <div>{item.video_url}</div>

                                  <div>{item.short_description}</div>
                                </div>
                              );
                            }

                            case "form": {
                              const globalFormNumber = formCounter++; // ✅ use then increment
                              const label = (
                                <h2 style={{ color: "#333", fontSize: "20px" }}>
                                  Form {globalFormNumber}
                                </h2>
                              );
                              // render form block here
                              return (
                                <div key={label}>
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                    }}
                                  >
                                    <label
                                      style={{
                                        display: "flex",
                                        gap: "6px",
                                        cursor: "pointer",
                                        marginTop: "20px",
                                      }}
                                    >
                                      {label}
                                    </label>

                                    <div
                                      className="header-spacing"
                                      style={{
                                        color: "#888",
                                        fontSize: "14px",
                                        fontWeight: "normal",
                                      }}
                                    >
                                      Section {index + 1} &gt; Step{" "}
                                      {globalStepNumber}
                                    </div>
                                  </div>
                                  <div>{item.short_description}</div>
                                </div>
                              );
                            }
                            case "canvas": {
                              const pages = getPages(item);

                              const globalCanvasNumber = canvasCounter++; // ✅ use then increment
                              const label = (
                                <h3 style={{ color: "#333", fontSize: "20px" }}>
                                  Canvas {globalCanvasNumber}
                                </h3>
                              );
                              const shapes = item.shapes || [];

                              return (
                                <div
                                  className="header-spacing"
                                  key={label}
                                  style={{ marginTop: "40px" }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                    }}
                                  >
                                    <label
                                      style={{
                                        display: "flex",
                                        gap: "6px",
                                        cursor: "pointer",
                                      }}
                                    >
                                      <h2>{label}</h2>
                                    </label>

                                    <div
                                      style={{
                                        color: "#888",
                                        fontSize: "14px",
                                        fontWeight: "normal",
                                      }}
                                    >
                                      Section {index + 1} &gt; Step{" "}
                                      {globalStepNumber}
                                    </div>
                                  </div>

                                  <div>{item.short_description}</div>
                                  {/* Display all pages vertically */}
                                  <CanvasDisplay
                                    pages={pages}
                                    hasUserContent={hasUserContent}
                                    getTextStyle={getTextStyle}
                                    stripHtmlPreserveFormatting={
                                      stripHtmlPreserveFormatting
                                    }
                                    estimateKonvaTextHeight={
                                      estimateKonvaTextHeight
                                    }
                                    formatListContent={formatListContent}
                                    hasNoteContent={hasNoteContent}
                                    hasTaskContent={hasTaskContent}
                                    calculateGroupHeight={calculateGroupHeight}
                                    calculateTextBlockWidth={
                                      calculateTextBlockWidth
                                    }
                                  />
                                </div>
                              );
                            }
                            case "attachment": {
                              const attachmentList = item.attachments || [];
                              if (attachmentList.length === 0) return null;

                              //  const globalAttachmentNumber =
                              //           attachmentCounter++; // ✅ use then increment
                              const globalAttachmentNumber =
                                attachmentCounter++; // ✅ Increment here per attachment
                              const label = (
                                <h2 style={{ color: "#333", fontSize: "20px" }}>
                                  Attachment {globalAttachmentNumber}
                                </h2>
                              );

                              return (
                                <div className="header-spacing" key={item}>
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                    }}
                                  >
                                    <label
                                      style={{
                                        display: "flex",
                                        gap: "6px",
                                        cursor: "pointer",
                                        marginTop: "20px",
                                      }}
                                    >
                                      {label}
                                    </label>

                                    <div
                                      style={{
                                        color: "#888",
                                        fontSize: "14px",
                                        fontWeight: "normal",
                                      }}
                                    >
                                      Section {index + 1} &gt; Step{" "}
                                      {globalStepNumber}
                                    </div>
                                  </div>
                                  <div>{item.short_description}</div>
                                  {attachmentList.map((attachment, i) => (
                                    <div key={i} style={{ marginLeft: "20px" }}>
                                      {renderPreview(attachment)}
                                    </div>
                                  ))}
                                </div>
                              );
                            }
                            default:
                              return null;
                          }
                        })}

                        {/* Substeps */}
                        {(substepsByStepPreview[stepId] || []).map(
                          (substep, substepIndex) => {
                            const substepId = substep.sub_step_tree_node_id;
                            const combinedItems = [
                              ...(richTexts[substepId] || []).map((item) => ({
                                ...item,
                                type: "richText",
                              })),
                              ...(forms[substepId] || []).map((item) => ({
                                ...item,
                                type: "form",
                              })),
                              ...(attachments[substepId] || []).map((item) => ({
                                ...item,
                                type: "attachment",
                              })),
                              ...(canvases[substepId] || []).map((item) => ({
                                ...item,
                                type: "canvas",
                              })),
                              ...(videos[substepId] || []).map((item) => ({
                                ...item,
                                type: "video",
                              })),
                              ...(richTextsForSubsteps[substepId] || []).map(
                                (item) => ({
                                  ...item,
                                  type: "richText",
                                })
                              ),
                              ...(formsForSubsteps[substepId] || []).map(
                                (item) => ({
                                  ...item,
                                  type: "form",
                                })
                              ),
                              ...(attachmentsForSubsteps[substepId] || []).map(
                                (item) => ({
                                  ...item,
                                  type: "attachment",
                                })
                              ),
                              ...(canvasesForSubsteps[substepId] || []).map(
                                (item) => ({
                                  ...item,
                                  type: "canvas",
                                })
                              ),
                              ...(videosForSubsteps[substepId] || []).map(
                                (item) => ({
                                  ...item,
                                  type: "video",
                                })
                              ),
                            ]; // Filter out substeps or unwanted items (same as your current filter)
                            const filteredItems = combinedItems;

                            filteredItems.sort((a, b) => {
                              const orderA =
                                a.sibling_order ||
                                a.procedure_tree?.sibling_order;
                              const orderB =
                                b.sibling_order ||
                                b.procedure_tree?.sibling_order;

                              const orderCompare = compareSiblingOrders(
                                orderA,
                                orderB
                              );
                              if (orderCompare !== 0) return orderCompare;

                              // Fallback: compare created_at
                              const dateA = new Date(a.created_at);
                              const dateB = new Date(b.created_at);
                              return dateB - dateA; // latest comes first
                            });

                            // Global step number (same logic you already use for steps)
                            const stepsBeforeThisOne =
                              previewSections
                                .slice(0, index)
                                .reduce((sectionAcc, s) => {
                                  const steps =
                                    stepsBySection[s.section_tree_node_id] ||
                                    [];
                                  return sectionAcc + steps.length;
                                }, 0) + stepIndex;

                            const globalStepNumber = stepsBeforeThisOne + 1;

                            // Final substep label like Substep 5A
                            const substepLetter = String.fromCharCode(
                              65 + substepIndex
                            ); // A, B, C, ...
                            const newSubstepLetter = String.fromCharCode(
                              65 + substepIndex + 1
                            );
                            const allChildrenUnderSubstep = [
                              ...(richTexts[substepId] || []),
                              ...(forms[substepId] || []),
                              ...(attachments[substepId] || []),
                              ...(canvases[substepId] || []),
                              ...(videos[substepId] || []),
                            ];
                            const globalSubstepLabel = `Substep ${globalStepNumber}${substepLetter}`;

                            const globalRichTextNumber = richTextCounter; // ✅ use then increment
                            const globalAttachmentNumber = attachmentCounter;
                            const globalVideoNumber = videoCounter;
                            const globalCanvasNumber = canvasCounter;
                            const globalFormNumber = formCounter;

                            return (
                              <div
                                className="header-spacing"
                                key={substepId}
                                style={{ marginTop: "20px" }}
                              >
                                <div>
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                    }}
                                  >
                                    <label
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        width: "100%",
                                      }}
                                    >
                                      <h2
                                        style={{
                                          margin: 0,
                                          color: "#333",
                                          fontSize: "20px",
                                        }}
                                      >
                                        {globalSubstepLabel}
                                      </h2>
                                      <div
                                        style={{
                                          color: "#888",
                                          fontSize: "14px",
                                          fontWeight: "normal",
                                        }}
                                      >
                                        Section {index + 1} &gt; Step{" "}
                                        {globalStepNumber} &gt; Substep{" "}
                                        {globalStepNumber}
                                        {substepLetter}
                                      </div>
                                    </label>
                                  </div>

                                  <div style={{ whiteSpace: 'pre-wrap' }}>{substep.short_description}</div>
                                </div>

                                {/* Substep Rich Texts */}
                                {filteredItems.map((item) => {
                                  switch (item.type) {
                                    case "richText": {
                                      const globalRichTextNumber =
                                        richTextCounter++; // ✅ use then increment
                                      // render richText block here
                                      const label = (
                                        <h2
                                          style={{
                                            color: "#333",
                                            fontSize: "20px",
                                          }}
                                        >
                                          Rich Text {globalRichTextNumber}
                                        </h2>
                                      );

                                      return (
                                        <div
                                          key={item.rich_text_tree_node_id}
                                          style={{ marginTop: "20px" }}
                                        >
                                          <div
                                            style={{
                                              display: "flex",
                                              justifyContent: "space-between",
                                              alignItems: "center",
                                            }}
                                          >
                                            <label
                                              style={{
                                                display: "flex",
                                                gap: "6px",
                                                cursor: "pointer",
                                              }}
                                            >
                                              {label}
                                            </label>

                                            <div
                                              style={{
                                                color: "#888",
                                                fontSize: "14px",
                                                fontWeight: "normal",
                                              }}
                                            >
                                              Section {index + 1} &gt; Step{" "}
                                              {globalStepNumber} &gt; Substep{" "}
                                              {globalStepNumber}
                                              {substepLetter}
                                            </div>
                                          </div>
                                          <div
                                            style={{
                                              marginLeft: "5px",
                                              marginTop: "-10px",
                                            }}
                                          >
                                            {item.short_description}
                                          </div>
                                          <div
                                            style={{
                                              marginLeft: "4px",
                                              marginTop: "5px",
                                            }}
                                          >
                                            {item.category_data?.category_name}
                                          </div>
                                          <div
                                            style={{
                                              fontSize: "14px",
                                              marginLeft: "4px",
                                              marginTop: "5px",
                                            }}
                                          >
                                            <div
                                              style={{ marginTop: "-6px" }}
                                              dangerouslySetInnerHTML={{
                                                __html: item.rich_text_content,
                                              }}
                                            />
                                          </div>
                                        </div>
                                      );
                                    }
                                    case "video": {
                                      const globalVideoNumber = videoCounter++; // ✅ use then increment
                                      const label = (
                                        <h2
                                          style={{
                                            color: "#333",
                                            fontSize: "20px",
                                          }}
                                        >
                                          Video {globalVideoNumber}
                                        </h2>
                                      );

                                      return (
                                        <div
                                          key={label}
                                          style={{ marginTop: "20px" }}
                                        >
                                          <div
                                            style={{
                                              display: "flex",
                                              justifyContent: "space-between",
                                              alignItems: "center",
                                            }}
                                          >
                                            <label
                                              style={{
                                                display: "flex",
                                                gap: "6px",
                                                cursor: "pointer",
                                              }}
                                            >
                                              {label}
                                            </label>

                                            <div
                                              style={{
                                                color: "#888",
                                                fontSize: "14px",
                                                fontWeight: "normal",
                                              }}
                                            >
                                              Section {index + 1} &gt; Step{" "}
                                              {globalStepNumber} &gt; Substep{" "}
                                              {globalStepNumber}
                                              {substepLetter}
                                            </div>
                                          </div>

                                          {renderVideo(item)}

                                          <div>{item.video_url}</div>

                                          <div>{item.short_description}</div>
                                        </div>
                                      );
                                    }

                                    case "form": {
                                      const globalFormNumber = formCounter++; // ✅ use then increment
                                      const label = (
                                        <h2
                                          style={{
                                            color: "#333",
                                            fontSize: "20px",
                                          }}
                                        >
                                          Form {globalFormNumber}
                                        </h2>
                                      );
                                      // render form block here
                                      return (
                                        <div
                                          className="header-spacing"
                                          key={label}
                                        >
                                          <div
                                            style={{
                                              display: "flex",
                                              justifyContent: "space-between",
                                              alignItems: "center",
                                            }}
                                          >
                                            <label
                                              style={{
                                                display: "flex",
                                                gap: "6px",
                                                cursor: "pointer",
                                                marginTop: "20px",
                                              }}
                                            >
                                              {label}
                                            </label>

                                            <div
                                              style={{
                                                color: "#888",
                                                fontSize: "14px",
                                                fontWeight: "normal",
                                              }}
                                            >
                                              Section {index + 1} &gt; Step{" "}
                                              {globalStepNumber} &gt; Substep{" "}
                                              {globalStepNumber}
                                              {substepLetter}
                                            </div>
                                          </div>
                                          <div>{item.short_description}</div>
                                        </div>
                                      );
                                    }
                                    case "canvas": {
                                      const pages = getPages(item);

                                      const globalCanvasNumber =
                                        canvasCounter++; // ✅ use then increment
                                      const label = (
                                        <h3
                                          style={{
                                            color: "#333",
                                            fontSize: "20px",
                                          }}
                                        >
                                          Canvas {globalCanvasNumber}
                                        </h3>
                                      );
                                      const shapes = item.shapes || [];

                                      return (
                                        <div
                                          className="header-spacing"
                                          key={label}
                                          style={{ marginTop: "40px" }}
                                        >
                                          <div
                                            style={{
                                              display: "flex",
                                              justifyContent: "space-between",
                                              alignItems: "center",
                                            }}
                                          >
                                            <label
                                              style={{
                                                display: "flex",
                                                gap: "6px",
                                                cursor: "pointer",
                                              }}
                                            >
                                              <h2>{label}</h2>
                                            </label>

                                            <div
                                              style={{
                                                color: "#888",
                                                fontSize: "14px",
                                                fontWeight: "normal",
                                              }}
                                            >
                                              Section {index + 1} &gt; Step{" "}
                                              {globalStepNumber} &gt; Substep{" "}
                                              {globalStepNumber}
                                              {substepLetter}
                                            </div>
                                          </div>

                                          <div>{item.short_description}</div>

                                          {/* Display all pages vertically */}
                                          <CanvasDisplay
                                            pages={pages}
                                            hasUserContent={hasUserContent}
                                            getTextStyle={getTextStyle}
                                            stripHtmlPreserveFormatting={
                                              stripHtmlPreserveFormatting
                                            }
                                            estimateKonvaTextHeight={
                                              estimateKonvaTextHeight
                                            }
                                            formatListContent={
                                              formatListContent
                                            }
                                            hasNoteContent={hasNoteContent}
                                            hasTaskContent={hasTaskContent}
                                            calculateGroupHeight={
                                              calculateGroupHeight
                                            }
                                            calculateTextBlockWidth={
                                              calculateTextBlockWidth
                                            }
                                          />
                                        </div>
                                      );
                                    }
                                    case "attachment": {
                                      const attachmentList =
                                        item.attachments || [];
                                      if (attachmentList.length === 0)
                                        return null;

                                      //  const globalAttachmentNumber =
                                      //           attachmentCounter++; // ✅ use then increment
                                      const globalAttachmentNumber =
                                        attachmentCounter++; // ✅ Increment here per attachment
                                      const label = (
                                        <h2
                                          style={{
                                            color: "#333",
                                            fontSize: "20px",
                                          }}
                                        >
                                          Attachment {globalAttachmentNumber}
                                        </h2>
                                      );

                                      return (
                                        <div
                                          className="header-spacing"
                                          key={item}
                                        >
                                          <div
                                            style={{
                                              display: "flex",
                                              justifyContent: "space-between",
                                              alignItems: "center",
                                            }}
                                          >
                                            <label
                                              style={{
                                                display: "flex",
                                                gap: "6px",
                                                cursor: "pointer",
                                                marginTop: "20px",
                                              }}
                                            >
                                              {label}
                                            </label>

                                            <div
                                              style={{
                                                color: "#888",
                                                fontSize: "14px",
                                                fontWeight: "normal",
                                              }}
                                            >
                                              Section {index + 1} &gt; Step{" "}
                                              {globalStepNumber} &gt; Substep{" "}
                                              {globalStepNumber}
                                              {substepLetter}
                                            </div>
                                          </div>
                                          <div>{item.short_description}</div>
                                          {attachmentList.map(
                                            (attachment, i) => (
                                              <div
                                                key={i}
                                                style={{ marginLeft: "20px" }}
                                              >
                                                {renderPreview(attachment)}
                                              </div>
                                            )
                                          )}
                                        </div>
                                      );
                                    }
                                    default:
                                      return null;
                                  }
                                })}
                              </div>
                            );
                          }
                        )}
                      </div>
                    );
                  })}
                </div>
              );
            })}
        </div>
      </div>

      {/* Snackbar */}
      {snackbar.open && (
        <Snackbar
          message={snackbar.message}
          type={snackbar.type}
          onClose={handleCloseSnackbar}
        />
      )}

      {/* Modal */}
      {isModalOpen && (
        <div className="modal-overlay">
          <div className="modal-content_addsection">
            {/* Header */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              <h4
                style={{
                  marginLeft: "23px",
                  fontSize: "18px",
                  color: "#333333",
                }}
              >
                Confirm Copy of {title}
              </h4>
              <button
                onClick={() => setModalOpen(false)}
                style={{
                  position: "absolute",
                  right: "10px",
                  top: "10px",
                  background: "none",
                  border: "none",
                  fontSize: "20px",
                  cursor: "pointer",
                  color: "#666",
                }}
                disabled={isLoading}
              >
                ✕
              </button>
            </div>

            {/* Modal Body */}
            <div
              style={{ padding: "24px", marginTop: "-28px", color: "#333333" }}
            >
              <h4 style={{ fontSize: "14px" }}>
                For {partNumber} &gt; Rev {revision} &gt; {treeNode}
              </h4>

              <p style={{ fontSize: "14px", color: "#333333" }}>
                <strong>Editor:</strong>{" "}
                <span style={{ marginLeft: "10px" }}>
                  {localStorage.getItem("user_name")}
                </span>
              </p>

              <label
                className="modal-label"
                style={{ fontSize: "14px", color: "#333333" }}
              >
                Comment
                <span className="required" style={{ marginLeft: "-1px" }}>
                  *
                </span>
              </label>
              <textarea
                className="modal-textarea"
                placeholder="Enter your comments here..."
                value={comment}
                onChange={(e) => setComment(e.target.value)}
                style={{
                  width: "100%",
                  minHeight: "100px",
                  padding: "8px",
                  border: "1px solid #ddd",
                  borderRadius: "4px",
                }}
                disabled={isLoading}
              ></textarea>
            </div>

            {/* Footer */}
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "10px",
                padding: "16px 24px",
                borderTop: "1px solid #e0e0e0",
                marginTop: "-10px",
                position: "relative",
              }}
            >
              {/* {isLoading && (
                <div
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "rgba(255, 255, 255, 0.7)",
                    zIndex: 10,
                  }}
                >
                  <div
                    className="loader-spinner"
                    style={{
                      border: "4px solid #f3f3f3",
                      borderRadius: "50%",
                      width: "20px",
                      height: "20px",
                      animation: "spin 1s linear infinite",
                      marginRight: "10px",
                    }}
                  ></div>
                  <span>Processing...</span>
                </div>
              )} */}
              <button
                onClick={() => setModalOpen(false)}
                style={{
                  padding: "8px 16px",
                  border: "1px solid #ccc",
                  borderRadius: "4px",
                  background: "#6c757d",
                  color: "#e9ecef",
                  cursor: isLoading ? "not-allowed" : "pointer",
                }}
                disabled={isLoading}
              >
                Close
              </button>
              <button
                onClick={handleConfirmSave}
                style={{
                  padding: "8px 16px",
                  border: "1px solid #007bff",
                  borderRadius: "4px",
                  background: "#007bff",
                  color: "white",
                  cursor: isLoading ? "not-allowed" : "pointer",
                  opacity: isLoading ? 0.7 : 1,
                }}
                disabled={isLoading}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      )}
      <div style={{ height: "100px" }}></div>
    </div>
  );
};

export default ProcedureSubstepCopyPreview;
